<!-- Header -->
<header class="bg-blue-600 shadow-lg relative z-50">
  <div class="container mx-auto px-4 py-4">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <h1 class="text-white text-2xl font-bold" routerLink="/" style="cursor: pointer;">Current-ly Connected</h1>
      </div>
      <nav class="hidden md:flex space-x-6">
        <a routerLink="/" routerLinkActive="text-blue-200" [routerLinkActiveOptions]="{exact: true}"class="text-white hover:text-blue-200 transition duration-300">Home</a>
        <a routerLink="/how-it-works" routerLinkActive="text-blue-200" class="text-white hover:text-blue-200 transition duration-300">How it works</a>
        <a routerLink="/about" routerLinkActive="text-blue-200" class="text-white hover:text-blue-200 transition duration-300">About</a>
      </nav>
      <!-- Mobile menu button -->
      <button 
        class="md:hidden text-white focus:outline-none mobile-menu-button"
        (click)="toggleMobileMenu(); $event.stopPropagation()"
        aria-label="Toggle mobile menu"
      >
        <svg 
          class="h-6 w-6" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
          [class.hidden]="showMobileMenu"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <svg 
          class="h-6 w-6" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
          [class.hidden]="!showMobileMenu"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  
  <!-- Mobile menu panel -->
  <div 
    class="mobile-menu md:hidden absolute w-full bg-blue-700 shadow-xl transition-all duration-300 ease-in-out"
    [class.h-0]="!showMobileMenu"
    [class.h-auto]="showMobileMenu"
    [class.py-0]="!showMobileMenu"
    [class.py-4]="showMobileMenu"
    [class.opacity-0]="!showMobileMenu"
    [class.opacity-100]="showMobileMenu"
    [class.invisible]="!showMobileMenu"
    [class.visible]="showMobileMenu"
  >
    <div class="container mx-auto px-4">
      <nav class="flex flex-col space-y-4">
        <a routerLink="/" routerLinkActive="bg-blue-800" [routerLinkActiveOptions]="{exact: true}" class="text-white hover:bg-blue-600 py-2 px-4 rounded transition duration-200">Home</a>
        <a routerLink="/how-it-works" routerLinkActive="bg-blue-800" class="text-white hover:bg-blue-600 py-2 px-4 rounded transition duration-200">How it works</a>
        <a routerLink="/about" routerLinkActive="bg-blue-800" class="text-white hover:bg-blue-600 py-2 px-4 rounded transition duration-200">About</a>
      </nav>
    </div>
  </div>
</header>

<!-- Main content area -->
<main class="min-h-screen">
  <!-- Home page content (only show on home route) -->
  <div *ngIf="router.url === '/'">
    <!-- Hero section -->
    <section class="bg-gray-100 py-12">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto text-center">
          <h2 class="text-4xl font-bold text-gray-800 mb-4">Welcome to Current-ly Connected</h2>
          <p class="text-xl text-gray-600 mb-8">A modern web platform built with Angular and styled with Tailwind CSS</p>
          <div class="flex justify-center space-x-4">
            <button routerLink="/inverter-stats" class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300">
              View Inverter Stats
            </button>
            <button routerLink="/features" class="bg-transparent hover:bg-blue-100 text-blue-600 font-semibold py-3 px-6 border border-blue-600 rounded-lg transition duration-300">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Features section -->
    <section class="py-16 bg-white">
      <div class="container mx-auto px-4">
        <h3 class="text-3xl font-bold text-center mb-12">Key Features</h3>
        
        <div class="grid md:grid-cols-3 gap-8">
          <!-- Feature 1 -->
          <div class="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
            <div class="bg-blue-100 text-blue-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h4 class="text-xl font-semibold mb-2">Real-time Monitoring</h4>
            <p class="text-gray-600">Monitor your inverter statistics in real-time with our powerful graphing engine.</p>
          </div>
          
          <!-- Feature 2 -->
          <div class="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
            <div class="bg-blue-100 text-blue-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
            </div>
            <h4 class="text-xl font-semibold mb-2">Customizable Views</h4>
            <p class="text-gray-600">Customize time ranges and data aggregation to view your data exactly how you need it.</p>
          </div>
          
          <!-- Feature 3 -->
          <div class="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
            <div class="bg-blue-100 text-blue-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h4 class="text-xl font-semibold mb-2">Firebase Integration</h4>
            <p class="text-gray-600">Securely store and retrieve your inverter data with Firebase backend integration.</p>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Router outlet container - this is where our components will be rendered -->
  <div class="container mx-auto px-4 py-8">
    <!-- When on a route other than home, show a breadcrumb -->
    <div *ngIf="router.url !== '/'" class="mb-6">
      <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-3">
          <li class="inline-flex items-center">
            <a routerLink="/" class="text-gray-700 hover:text-blue-600 inline-flex items-center">
              <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
              Home
            </a>
          </li>
          <!-- Dynamic breadcrumb segment based on route -->
          <li aria-current="page">
            <div class="flex items-center">
              <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-gray-500 ml-1 md:ml-2 font-medium" *ngIf="router.url === '/golden-fields'">Golden Fields</span>
              <span class="text-gray-500 ml-1 md:ml-2 font-medium" *ngIf="router.url === '/how-it-works'">How It Works</span>
              <span class="text-gray-500 ml-1 md:ml-2 font-medium" *ngIf="router.url === '/about'">About</span>
            </div>
          </li>
        </ol>
      </nav>
    </div>

    <!-- Router outlet - where our components will be rendered -->
    <router-outlet></router-outlet>
  </div>
</main>

<!-- Footer -->
<footer class="bg-gray-800 text-white py-8 mt-auto">
  <div class="container mx-auto px-4">
    <div class="flex flex-col md:flex-row justify-between items-center">
      <div class="mb-4 md:mb-0">
        <h4 class="text-xl font-bold">Current-ly Connected</h4>
        <p class="text-gray-400">© {{currentYear}} How do I reserve rights? 😂</p>
      </div>
      <div class="flex space-x-4">
        <!-- <a href="#" class="text-gray-400 hover:text-white transition duration-300" aria-label="Twitter">
          <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
          </svg>
        </a>
        <a href="#" class="text-gray-400 hover:text-white transition duration-300" aria-label="GitHub">
          <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
          </svg>
        </a> -->
        <a href="https://www.linkedin.com/in/michael-relling/" class="text-gray-400 hover:text-white transition duration-300" aria-label="LinkedIn">
          <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</footer>
